import { isEmpty } from "Util/isEmpty";

import { Email } from "./Email";
import { Name } from "./Name";
import { Nullable } from "./Nullable";
import { Phone } from "./Phone";

export type ContactInfo = {
    name: Nullable<Name>
    phone: Nullable<Phone>
    email: Nullable<Email>
}

export function contactInfoFrom(name: Nullable<Name>, phone: Nullable<Phone>, email: Nullable<Email>): Nullable<ContactInfo> {
    if (isEmpty([name, email, phone])) {
        return null
    }
    return {
        name,
        email,
        phone,
    }
}
